import { render, staticRenderFns } from "./ReqDimensionsDialog.vue?vue&type=template&id=5e72c9e0&scoped=true"
import script from "./ReqDimensionsDialog.vue?vue&type=script&lang=js"
export * from "./ReqDimensionsDialog.vue?vue&type=script&lang=js"
import style0 from "./ReqDimensionsDialog.vue?vue&type=style&index=0&id=5e72c9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72c9e0",
  null
  
)

export default component.exports